export const APP_NAME = process.env.REACT_APP_APP_NAME || '¡Oh! Belleza Pedidos';
export const APP_REGION = process.env.REACT_APP_REGION || '';
export const VENDOR_LOCKED = false;
export const STORAGE_KEY = 'oh_vendedor';
